// ⚡ Performance Optimizer Component
// Applique les optimisations globales pour toute l'application

import { useEffect } from 'react';
import { gsap } from 'gsap';
import { detectPerformanceCapabilities } from '../utils/performanceUtils';

const PerformanceOptimizer = () => {
  useEffect(() => {
    const perf = detectPerformanceCapabilities();
    
    // ⚡ Apply global optimizations
    if (perf.shouldReduceAnimations) {
      // 🎯 Set GSAP global optimizations
      gsap.defaults({
        duration: 0.5, // Faster default duration
        ease: "power2.out", // Simpler easing
        force3D: true, // GPU acceleration
      });
      
      // 🔄 Reduce ticker frequency for battery
      if (perf.isLowBattery) {
        gsap.ticker.fps(30); // Instead of 60fps
      }
      
      // 🎮 Global CSS optimizations
      const style = document.createElement('style');
      style.textContent = `
        /* ⚡ GPU Acceleration for all animated elements */
        .hero-container-main,
        .menu-image-display-fixed,
        .floating-bubble,
        .pearl,
        .wave-particle,
        .cloud-particle,
        .bg-particle {
          will-change: transform;
          transform: translateZ(0);
          backface-visibility: hidden;
        }
        
        /* 🔋 Disable animations on very low-end devices */
        ${perf.shouldDisableParticles ? `
          .floating-bubble,
          .pearl,
          .wave-particle,
          .cloud-particle,
          .bg-particle {
            display: none !important;
          }
        ` : ''}
        
        /* 📱 Mobile-specific optimizations */
        @media (max-width: 768px) {
          * {
            animation-duration: 0.3s !important;
            transition-duration: 0.3s !important;
          }
        }
        
        /* 🐌 Slow connection optimizations */
        ${perf.isSlowConnection ? `
          .hero-main::before,
          .about-wave,
          .menu-image-display-fixed {
            background: none !important;
            box-shadow: none !important;
          }
        ` : ''}
      `;
      
      document.head.appendChild(style);
      
      // Cleanup function
      return () => {
        document.head.removeChild(style);
      };
    }
    
    // 🎉 High performance mode
    else {
      gsap.defaults({
        duration: 1.0,
        ease: "power3.out",
        force3D: true,
      });
    }
  }, []);
  
  return null; // This component doesn't render anything
};

export default PerformanceOptimizer;